import styled from 'styled-components';
import { calcResize } from 'components/Layout/styles';
import { Col } from 'react-bootstrap';

export const SHeader = styled.div`
  width: 100%;
`;
export const SBody = styled.div`
  width: 100%;
`;
export const SFooter = styled.div`
  width: 100%;
`;

export const SCol = styled(Col).attrs(() => ({
  className: 'justify-content-center col-auto',
}))`
  position: relative;
  @media screen and (min-width: 1200px) {
    top: ${props => props.$moveUp && '-50px'};
  }
`;

export const SCard = styled.div`
  max-width: ${calcResize(240, 280)};
  //height: ${props => (props.inLine ? '100%' : '370px')};
  margin-bottom: ${props => !props.inLine && '30px'};
  margin-top: ${props => props.inLine && '30px'};
  margin-inline: auto;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  border-radius: 5px;
  box-shadow: 0 4px 68px 0 rgba(12, 65, 133, 0.1);
  background-color: white;
  padding: 35px 20px 0;
  justify-content: space-between;

  p {
    color: #192f54;
    //margin-top: 16px;

    &.title {
      font-size: ${calcResize(25, 28)};
      height: ${props => (props.inLine ? props.titleHeight + 'px' : 'auto')};
      font-weight: bold;
      line-height: 1.09;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &.description {
      font-size: ${calcResize(13, 15)};
      height: ${props =>
        props.inLine ? props.descriptionHeight + 'px' : 'auto'};
    }

    &.footer {
      font-size: ${calcResize(13, 15)};
      height: ${props => (props.inLine ? props.footerHeight + 'px' : 'auto')};
    }
  }
`;

export const SIcon = styled.div`
  display: flex;
  align-self: center;
  background-color: #f5f7fb;
  height: 75px;
  width: 75px;
  border-radius: 50px;
  margin: 0 auto 16px;

  svg {
    width: 100%;
    height: 30px;
    align-self: center;
    fill: #325da5;
  }
`;
